// src/components/Navbar.js

import React from 'react';
import { Link } from 'react-router-dom'; // Import Link for navigation
import './Navbar.css'; // Import CSS for styling

function Navbar() {
  return (
    <div className="navbar-container">
      <nav className="navbar z-50">
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/browse">Browse</Link></li>
          <li><Link to="/downloads">Downloads</Link></li>
        </ul>
      </nav>
    </div>
  );
}

export default Navbar;